import "./SectionTitle.scss";
import Tags from "../../UI/Tags/Tags";

const SectionTitle = ({ title, description, icon = false }) => {
  return (
    <div className="section__titles">
      {icon ? <Tags tag={icon} /> : ""}
      <h2 className="section__title">
        {title}
        <span className="section__title-line"></span>
      </h2>

      <p className="section__description">{description}</p>
    </div>
  );
};

export default SectionTitle;